export const PERMISSIONS = {
  LAND: {
    VIEW: 'VIEW_LAND_AREA',
  },
  HARVEST: {
    VIEW: 'VIEW_HARVEST',
  },
  COSMIC_MONITORING: {
    VIEW: 'VIEW_COSMIC',
  },
  BURSE: {
    VIEW: 'VIEW_BURSE',
  },
  BANK: {
    VIEW: 'VIEW_BANK',
  },
  AGROPORTAL: {
    VIEW: 'VIEW_AGROPORTAL',
  },
  AGROSUBSIDIYA: {
    VIEW: 'VIEW_SUBSIDIYA',
  },
  INSURANCE: {
    VIEW: 'VIEW_INSURANCE',
  },
  MATERIAL_CONTROL: {
    VIEW: 'VIEW_MATERIAL_RESOURCE',
  },
  SEEDS: {
    VIEW: 'VIEW_SEEDS',
  },
  USERS: {
    VIEW: 'VIEW_USER',
    CREATE: 'CREATE_USER',
    UPDATE: 'UPDATE_USER',
    DELETE: 'DELETE_USER',
  },
  ROLES: {
    VIEW: 'VIEW_ROLE',
    CREATE: 'CREATE_ROLE',
    UPDATE: 'UPDATE_ROLE',
    DELETE: 'DELETE_ROLE',
  },
} as const;

type PermissionGroups = typeof PERMISSIONS;

export type PermissionCode = {
  [Group in keyof PermissionGroups]: PermissionGroups[Group][keyof PermissionGroups[Group]];
}[keyof PermissionGroups];

export const PAGE_PERMISSIONS = {
  LAND: [PERMISSIONS.LAND.VIEW],
  HARVEST: [PERMISSIONS.HARVEST.VIEW],
  COSMIC_MONITORING: [PERMISSIONS.COSMIC_MONITORING.VIEW],
  BURSE: [PERMISSIONS.BURSE.VIEW],
  BANK: [PERMISSIONS.BANK.VIEW],
  INSURANCE: [PERMISSIONS.INSURANCE.VIEW],
  AGROPORTAL: [PERMISSIONS.AGROPORTAL.VIEW],
  AGROSUBSIDIYA: [PERMISSIONS.AGROSUBSIDIYA.VIEW],
  MATERIAL_CONTROL: [PERMISSIONS.MATERIAL_CONTROL.VIEW],
  SEEDS: [PERMISSIONS.SEEDS.VIEW],
  USERS: {
    INDEX: [
      PERMISSIONS.USERS.VIEW,
      PERMISSIONS.USERS.CREATE,
      PERMISSIONS.USERS.UPDATE,
      PERMISSIONS.USERS.DELETE,
    ],
    CREATE: [PERMISSIONS.USERS.CREATE],
    EDIT: [PERMISSIONS.USERS.UPDATE],
  },
  ROLES: {
    INDEX: [
      PERMISSIONS.ROLES.VIEW,
      PERMISSIONS.ROLES.CREATE,
      PERMISSIONS.ROLES.UPDATE,
      PERMISSIONS.ROLES.DELETE,
    ],
    CREATE: [PERMISSIONS.ROLES.CREATE],
    EDIT: [PERMISSIONS.ROLES.UPDATE],
  },
} as const;
